import LZString from 'lz-string';

export const FILTER_KEY = 'filters';

export const getDecompressedFilters = <T>(searchParams: URLSearchParams): T | null => {
    const filters = searchParams.get(FILTER_KEY);

    if (filters) {
        try {
            const decompressedFilters = LZString.decompressFromEncodedURIComponent(filters);
            return decompressedFilters ? JSON.parse(decompressedFilters) as T : null;
        } catch {
            return null;
        }
    }

    return null;
};
